import React from "react";
import { AddInter } from "../../interface/interface";
import ImageInput from "../WriteProject/ImageInput/ImageInput";
import "./css/index.css";
type Props = {
  data: AddInter;
  UpdateInfo: (type: string, payload: string | number) => void;
  WritePost: () => void;
  addType: "new" | "fix" | "line";
};

const AddCreate = ({
  data: { ctts_tit, bg_color, ad_thumbnail, ctts_link, ctts_ctts, btn_label },
  UpdateInfo,
  WritePost,
  addType,
}: Props) => {
  return (
    <main className="add-create-section">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>
              {addType === "new"
                ? "신규 광고 업로드"
                : addType === "fix"
                ? "광고 수정"
                : "띠배너"}
            </p>
          </div>
          <div className="right">
            {addType !== "line" ? (
              <button className="view-btn">미리보기</button>
            ) : undefined}
            <button className="insert-btn" onClick={WritePost}>
              등록하기
            </button>
          </div>
        </div>
        <div
          className={`add-create-content-section ${addType}-content-section`}
        >
          <div className="add-create-content-left">
            <div className="textarea-section">
              <div className="title">
                타이틀 <span>개행가능</span>
              </div>
              <div className="textarea-wrapper">
                <textarea
                  className="textarea"
                  placeholder="타이틀을 입력해주세요"
                  value={ctts_tit}
                  maxLength={29}
                  onChange={(e) => {
                    UpdateInfo("add/title", e.target.value);
                  }}
                ></textarea>
                <div className="number">{ctts_tit.length}/30</div>
              </div>
            </div>
            {addType !== "line" ? (
              <div className="textarea-section">
                <div className="title">
                  소개글 <span>개행가능</span>
                </div>
                <div className="textarea-wrapper">
                  <textarea
                    className="textarea"
                    placeholder="소개글을 입력해주세요"
                    value={ctts_ctts}
                    maxLength={56}
                    onChange={(e) => {
                      UpdateInfo("add/content", e.target.value);
                    }}
                  ></textarea>
                  <div className="number">{ctts_ctts.length}/57</div>
                </div>
              </div>
            ) : (
              <>
                <div className="add-create-btn-section">
                  <div className="title">설명</div>
                  <div className="btn-input-wrapper">
                    <input
                      type="text"
                      placeholder="설명을 입력해주세요"
                      className="input"
                      value={ctts_ctts}
                      maxLength={20}
                      onChange={(e) => {
                        UpdateInfo("add/content", e.target.value);
                      }}
                    ></input>
                    <div className="number">{ctts_ctts.length}/20</div>
                  </div>
                </div>
                <div className="add-create-btn-section">
                  <div className="title">버튼명</div>
                  <div className="btn-input-wrapper">
                    <input
                      type="text"
                      placeholder="버튼명을 입력해주세요"
                      className="input"
                      value={btn_label}
                      maxLength={7}
                      onChange={(e) => {
                        UpdateInfo("add/btn", e.target.value);
                      }}
                    ></input>
                    <div className="number">{btn_label.length}/7</div>
                  </div>
                </div>
              </>
            )}
            <div className="add-create-link">
              <div className="title">링크</div>
              <div className="link-tag">
                <img src="/assets/common/add_link.svg" alt="링크"></img>
                <input
                  type="url"
                  placeholder="링크를 입력해주세요"
                  className="input"
                  value={ctts_link}
                  onChange={(e) => {
                    UpdateInfo("add/link", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="add-create-color-section">
              <div className="title">
                배경컬러 <span>택 1</span>
              </div>
              <div className="add-create-color-list">
                {color.map((item, index) => {
                  return (
                    <button
                      key={index}
                      className={`add-color-btn ${
                        item === bg_color ? "add-color-select" : ""
                      }`}
                      onClick={() => {
                        UpdateInfo("add/color", item);
                      }}
                    >
                      <div className="name">{item}</div>
                      <div
                        className={`add-card-color ${
                          item === "Green"
                            ? "color-green"
                            : item === "Blue"
                            ? "color-blue"
                            : item === "Skyblue"
                            ? "color-sky-blue"
                            : item === "Purple"
                            ? "color-purple"
                            : "color-black"
                        }`}
                      />
                    </button>
                  );
                })}
              </div>
            </div>
            {addType !== "line" ? (
              <div className="add-create-btn-section">
                <div className="title">버튼 Label</div>
                <div className="btn-input-wrapper">
                  <input
                    type="text"
                    placeholder="버튼 레이블을 입력해주세요"
                    className="input"
                    value={btn_label}
                    maxLength={7}
                    onChange={(e) => {
                      UpdateInfo("add/btn", e.target.value);
                    }}
                  ></input>
                  <div className="number">{btn_label.length}/7</div>
                </div>
              </div>
            ) : (
              <div className="line-img-section">
                <ImageInput
                  title="이미지"
                  sub={`png 확장자 / 160x160px 권장`}
                  data={ad_thumbnail}
                  __update={UpdateInfo}
                  isError={false}
                  type={"add/img"}
                />
              </div>
            )}
          </div>
          <div className="add-create-content-right">
            {addType !== "line" ? (
              <ImageInput
                title="썸네일 이미지"
                sub={`707x577px 권장 / 20mb 이내
jpg / png 확장자`}
                data={ad_thumbnail}
                __update={UpdateInfo}
                isError={false}
                type={"add/img"}
              />
            ) : (
              <>
                <div className="title">미리보기</div>
                <div
                  className={`view-line-add ${
                    bg_color === "Green"
                      ? "color-green"
                      : bg_color === "Blue"
                      ? "color-blue"
                      : bg_color === "Skyblue"
                      ? "color-sky-blue"
                      : bg_color === "Purple"
                      ? "color-purple"
                      : "color-black"
                  }`}
                >
                  <div className={`view-line-add-content`}>
                    <div className="line-add-title">
                      {ctts_tit ? ctts_tit : "title"}
                    </div>
                    <div className="line-add-content">
                      {ctts_ctts ? ctts_ctts : "Content"}
                    </div>
                    <button className="line-add-btn">
                      {btn_label ? btn_label : "Button"}
                    </button>
                  </div>
                  <div className="view-line-add-img">
                    <img src={ad_thumbnail} alt="" />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default AddCreate;

const color = ["Black", "Blue", "Skyblue", "Green", "Purple"];
